$(document).ready(function(){
  $(document).on('keyup','.QtyInput',function(){
     var TotalPrice = 0;
     var TotalQty = 0
      $('.QtyInput').each(function(){
        var Qty = parseFloat($(this).val());
        var Price = parseFloat($(this).attr('price'));
        if(Qty > 0 && Qty != ''){
          if($(this).hasClass('PackagingInput')){
            if(Qty >= 4 && Qty <= 11){
              var Price = Price - (Price/10)
            }else if(Qty >= 12 && Qty <= 34){
               var Price = Price - (Price/15)
            }else if(Qty >= 35 && Qty <= 49){
               var Price = Price - (Price/20) 
            }else if(Qty >= 50) {
               var Price = Price - (Price/25);
            }else{
              
            }
            var itemcoast = Price*Qty;
            TotalPrice += itemcoast;
            if($(this).hasClass('SempleInput')){
              var AdditionalItemCost =  parseFloat($(this).attr('semplePrice'));
              var semplePrice = AdditionalItemCost*Qty;
              TotalPrice += semplePrice;
            }
          }else{
            var itemcoast = Price*Qty;
            TotalPrice += itemcoast;
            TotalQty+= Qty;
          }
       }
    }); 
    var TotalPrice = TotalPrice.toFixed(2);
    $(document).find('.Grandtotal').text('$ '+TotalPrice).attr('totalprice',TotalPrice);
  });
   $(document).on('click','#OptionActionbtn',function(){
      var TotalQty = 0
      var items = [];
      $('.QtyInput').each(function() {
        var Qty = parseFloat($(this).val());
        if(Qty > 0 && Qty != ''){
          var varId = $(this).attr('variantid');
          if($(this).hasClass('SempleInput')){
            var sempleId = $(this).attr('sempleid');
            items.push({id:sempleId,quantity: Qty})
          }
          items.push({id:varId,quantity: Qty})
          TotalQty+= Qty;
         }
      });
      if($(this).hasClass('NoItemSelected') || TotalQty != 0 ){
         $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
           items: items
          },
          dataType: 'json',
          beforeSend: function(data) {
             // $(this).addClass('loading')
          },
          success: function() {
            $(document).find('.ErrorMessage').fadeOut();
            window.location.href = '/cart'
          },
          error: function() {
            $(document).find('.ErrorMessage').fadeIn();
          }
        });
      }else{
         $(document).find('.ErrorMessage').fadeIn();
      }
    });
  // search sheet
  $(document).on('keyup','.itg_filterSearch', function() {
     var searchVal = $(this).val().toLowerCase();
	if ( searchVal != '' ) {
        $(".ITG_Pdf_Link").each(function () {
         if ($(this).find('a').text().toLowerCase().search(searchVal) > -1) {
            $(this).show();
         } else {
            $(this).hide();
         }
      });
	} else {
		$('.ITG_Pdf_Link').show();
	}
});
   $(document).on('click','.searchClear', function() {
   	$('.ITG_Pdf_Link').show();
    $('.itg_filterSearch').val('');
  });

    // var $id = $('.mainCategorie.active');
    // var pos = $id.offset().top - 200;
    // $('.CategoriesList').animate({scrollTop: pos});

});